import { Card } from "@heroui/card";
import { Loader2 } from "lucide-react";

interface TaskLoadingProps {
  message?: string;
}

export function TaskLoading({ message = "Loading..." }: TaskLoadingProps) {
  return (
    <Card className="p-6 bg-yiedl-gray-200 shadow-lg border-2 border-neutral-800 rounded-2xl w-full">
      <div className="flex flex-col items-center justify-center space-y-4 py-8">
        <Loader2 className="h-8 w-8 animate-spin text-yiedl-primary" />
        <p className="text-sm text-gray-400">{message}</p>
      </div>
    </Card>
  );
}
